import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import { ProfileCompletionSchema } from '../profile-completion';

/**
 * What a save of answers did about review (D6): nothing, opened a `re_review`
 * case, or joined the one already waiting in the queue.
 */
export const REVIEW_OUTCOMES = ['none', 'opened', 'merged'] as const;

export const ReviewOutcomeSchema = z.enum(REVIEW_OUTCOMES);

export type ReviewOutcome = (typeof REVIEW_OUTCOMES)[number];

/**
 * The answer to `POST /profile/answers`.
 *
 * The completion sits beside the review rather than carrying it: the client
 * caches the completion as the `/profile/completion` shape, and a review field
 * inside it would be cached — and stale — with it.
 */
export const SubmitAnswersResponseSchema = z
  .object({
    completion: ProfileCompletionSchema,
    review: z
      .object({
        outcome: ReviewOutcomeSchema,
        caseId: UuidSchema.nullable(),
      })
      .strict(),
  })
  .strict();

export type SubmitAnswersResponse = z.infer<typeof SubmitAnswersResponseSchema>;
